import * as React from "react";
import {
  classNames,
  UitkHeading,
  UitkIcon,
  UitkIconSize,
  UitkLink,
  UitkText
} from "../index.js";
export var UitkMessagingCardActionTypes = /* @__PURE__ */ ((UitkMessagingCardActionTypes2) => {
  UitkMessagingCardActionTypes2["close"] = "close";
  UitkMessagingCardActionTypes2["navigate"] = "nav";
  return UitkMessagingCardActionTypes2;
})(UitkMessagingCardActionTypes || {});
export function UitkMessagingCard({
  headingText,
  textValue,
  links,
  bodyUrl,
  action,
  onClickAction,
  className,
  style,
  icon,
  border,
  iconSpotlight,
  linkPosition = "below",
  a11yActionLabel
}) {
  const actionIcon = action == "close" /* close */ ? "close" : "chevron_right";
  const isClickableCard = action === "nav" /* navigate */ && typeof links != "object";
  const globalTheme = isClickableCard ? `uitk-card-messaging uitk-card-messaging-clickable` : `uitk-card-messaging`;
  const isLinkCard = !!bodyUrl;
  function DivCard(content) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(globalTheme, className, { border }),
        style,
        onClick: isClickableCard && onClickAction || void 0
      },
      content
    );
  }
  function LinkCard(content) {
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: classNames(globalTheme, className, { border }),
        style,
        href: bodyUrl,
        onClick: onClickAction || void 0
      },
      content
    );
  }
  function CardBody() {
    return /* @__PURE__ */ React.createElement("div", { className: "flex" }, icon ? /* @__PURE__ */ React.createElement("div", { className: "item left" }, /* @__PURE__ */ React.createElement(
      UitkIcon,
      {
        name: icon,
        spotlight: iconSpotlight ? "background" : void 0,
        theme: typeof iconSpotlight === "string" ? iconSpotlight : void 0,
        size: UitkIconSize.MEDIUM
      }
    )) : "", /* @__PURE__ */ React.createElement("div", { className: classNames("item center", { "link-right": linkPosition === "right" }) }, /* @__PURE__ */ React.createElement("div", { className: "text" }, /* @__PURE__ */ React.createElement(UitkHeading, { size: 7, tag: "h3" }, headingText), /* @__PURE__ */ React.createElement(UitkText, { size: 300, className: "uitk-type-300" }, textValue)), links && /* @__PURE__ */ React.createElement("div", { className: "links" }, links.map((link, i) => /* @__PURE__ */ React.createElement(
      UitkLink,
      {
        key: i,
        inline: true,
        noWrap: false,
        className: "uitk-link-layout-inline-no-decoration"
      },
      link
    )))), action && /* @__PURE__ */ React.createElement("div", { className: "item right" }, /* @__PURE__ */ React.createElement("button", { className: classNames("action", action), onClick: !isClickableCard && onClickAction || void 0 }, /* @__PURE__ */ React.createElement(UitkIcon, { name: actionIcon, className: "icon-theme-action" }), /* @__PURE__ */ React.createElement("span", { className: classNames("is-visually-hidden") }, a11yActionLabel))));
  }
  return isLinkCard ? LinkCard(CardBody()) : DivCard(CardBody());
}
